import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

const COLOR_CLASSES = {
  blue:   { bg: 'bg-blue-50',   border: 'border-blue-100',   iconText: 'text-blue-600' },
  green:  { bg: 'bg-green-50',  border: 'border-green-100',  iconText: 'text-green-600' },
  yellow: { bg: 'bg-yellow-50', border: 'border-yellow-100', iconText: 'text-yellow-600' },
  red:    { bg: 'bg-red-50',    border: 'border-red-100',    iconText: 'text-red-600' },
  indigo: { bg: 'bg-indigo-50', border: 'border-indigo-100', iconText: 'text-indigo-600' },
  gray:   { bg: 'bg-gray-50',   border: 'border-gray-200',   iconText: 'text-gray-500' },
};

// `interactive` marks the card as leading somewhere: it gains a hover state and
// a trailing arrow so it reads as clickable rather than as a static figure.
const StatCard = ({ label, value, icon: Icon, color = 'gray', trend, compact = false, interactive = false }) => {
  const c = COLOR_CLASSES[color] || COLOR_CLASSES.gray;

  return (
    <div
      className={`h-full rounded-2xl border ${c.border} ${c.bg} ${compact ? 'px-4 py-4' : 'px-5 py-5'} ${
        interactive
          ? 'group cursor-pointer transition-all hover:border-indigo-300 hover:shadow-sm'
          : ''
      }`}
    >
      <div className="flex items-center gap-3 mb-3">
        {Icon && (
          <div className="p-2 bg-white rounded-xl">
            <Icon className={`${c.iconText} text-lg`} />
          </div>
        )}
        <p className="text-xs font-medium text-gray-500 flex-1 min-w-0 truncate">{label}</p>
        {interactive && (
          <FiArrowRight className="w-3.5 h-3.5 shrink-0 text-gray-400 transition-all group-hover:translate-x-0.5 group-hover:text-indigo-500" />
        )}
      </div>
      <p className={`font-bold text-gray-900 ${compact ? 'text-lg' : 'text-2xl'}`}>{value}</p>
      {trend && (
        <p className={`mt-1 text-xs font-medium ${trend.direction === 'up' ? 'text-green-600' : 'text-red-500'}`}>
          {trend.direction === 'up' ? '▲' : '▼'} {trend.value}
        </p>
      )}
    </div>
  );
};

export default StatCard;
